import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="relative">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap" style={{height: "60vh"}}>
        <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            style={{ filter: "opacity(0.7)" }}
            src="https://maps.google.com/maps?q=Facultad%20de%20Informatica%20-%20UDC&t=&z=15&ie=UTF8&iwloc=&output=embed"
          />
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-2/5 px-6">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                ADDRESS
              </h2>
              <p className="mt-1">
                Camiño do Lagar de Castro, 6 <br />
                15008 A Coruña
              </p>
            </div>
            <div className="lg:w-3/5 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                EMAIL
              </h2>
              <a href className="text-indigo-400 leading-relaxed">
                jan.duinkerken.rodriguez@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div>
          <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
            Hire Me
          </h2>
          <p className="leading-relaxed mb-5">
            Even though I'm currently based in Spain I would love to have the
            opportunity to work abroad, so don't doubt contacting me!
          </p>
          <p>
            My contact email is <a href="mailto:jan.duinkerken.rodriguez@gmail.com">jan.duinkerken.rodriguez@gmail.com</a>
          </p>
        </div>
      </div>
    </section>
  );
}